import { get, postJSON, del, post } from '../utils/axios'

// 获取预约类型列表
export const getAppointmentTypeList = () => get('typeCfg/selectList')

// 查询预约类型详情
export const getAppointmentTypeInfo = (options) => get('typeCfg/selectByPk', options)

// 编辑预约类型配置
interface UpdateAppointmentTypeConfigOptions {
    pk: string
    week: string // 可预约周期
    remindTime: string // 到店提醒时间(分钟)
    status: '0' | '1' // 状态0-停用 1-开启
    confirmType: '0' | '1' // 确认类型 0-系统确认 1-人工确认
}
export const updateAppointmentTypeConfig = (options: UpdateAppointmentTypeConfigOptions) => postJSON('typeCfg/update', options)

// 新增编辑时间段配置
interface UpdateAppointmentTimesOptions {
    pk?: string // 预约时间段配置pk
    typePk: string // 预约类型PK
    startTime: string // 开始时间
    endTime: string // 截止时间
    maxNum: number // 最大预约人数
    remark: string // 预约说明
}
export const updateAppointmentTimes = (options: UpdateAppointmentTimesOptions) => postJSON('typeCfg/saveOrUpdate', options)

// 按预约类型pk查询时间段配置列表
export const deleteAppointmentTimes = (pk: string) => post('typeCfg/deleteTimeCfg', { pk })

// 按预约类型pk查询时间段配置列表
interface GetAppointmentTimeListOptions {
    appointmentDate: string // 预约日期
    typePk: string // 预约类型pk
    orgPk?: string
}
export const getAppointmentTimeList = (options: GetAppointmentTimeListOptions) => get('typeCfg/selectByTypePk', options)

// 预约单列表查询
interface GetAppointmentBillListOptions {
    page: number // 当前页
    orderBy?: string // 排序
    size: number // 每页大小
    searchName?: string // 姓名、手机号、车牌号查询条件
    status?: string // 状态0-待确认 1-已确认 2-已到店 3-已取消
    appointmentDate?: string // 预约日期
    typePk?: string // 预约类型pk
}
export const getAppointmentBillList = (options: GetAppointmentBillListOptions) => postJSON('appointmentBill/selectList', options)

// 查询预约单统计
export const getAppointmentBillTotal = (options: GetAppointmentBillListOptions) => postJSON('appointmentBill/billStatusStatistics', options)

// 根据时间段查询日历统计
interface GetAppointmentEveryDayTotalOptions {
    startTime: string
    endTime: string
}
export const getAppointmentEveryDayTotal = (options: GetAppointmentEveryDayTotalOptions) => post('appointmentBill/calendarStatistics', options)

// 取消预约单
interface CancelAppointmentBillOptions {
    billPk: string // 预约单pk
    cancelReason: string // 取消原因
}
export const cancelAppointmentBill = (options: CancelAppointmentBillOptions) => post('appointmentBill/cancelBill', options)

// 提交预约
interface SaveAppointmentBillOptions {
    userPk: string // 用户PK
    carNo: string // 车牌号
    mileage?: string // 公里数
    typePk: string // 预约类型PK
    cfgPk: string // 预约时间配置pk
    appointmentDate: string // 预约日期
    startTime: string // 开始时间
    endTime: string // 截止时间
    carOwnerRemark: string // 车主预约备注
    inviteRecordPk?: string //邀约记录pk
    orgPk?: string //门店pk
    appointmentType?: string | number //预约类型 0-小程序/H5 1-APP
}
export const saveAppointmentBill = (options: SaveAppointmentBillOptions) => postJSON('appointmentBill/saveAppointmentBill', options)

// 按搜索条件查询车辆客户列表(预约管理查询专用)
interface GetCustomerOrCarList {
    page: number // 页码
    size: number // 每页大小
    searchParam: string // 车牌、姓名、手机号
}
export const getCustomerOrCarList = (options: GetCustomerOrCarList) => post('car/carAndUserInfoList', options)

// 预约看板头部统计
export const getAppointmentBoardTotal = (options) => postJSON('appointmentBill/appointmentLookBoardStatistics', options)

// 预约看板-预约类型统计
interface GetAppointmentBoardTypeTotalOptions {
    queryStatus: string // 查询状态 0-今日 1-明日 2-未来7日
    status: string // 状态0-未到店 1-已到店
}
export const getAppointmentBoardTypeTotal = (options: GetAppointmentBoardTypeTotalOptions) => post('appointmentBill/appointmentTypeStatistics', options)

// 查询预约看板列表
interface GetAppointmentBoardListOptions {
    page: number // 当前页
    orderBy?: string // 排序
    size: number // 每页大小
    searchName?: string // 姓名、手机号、车牌号查询条件
    status?: string // 状态0-待确认 1-已确认 2-已到店 3-已取消
    appointmentDate?: string // 预约日期
    appointmentStartDate?: string // 预约开始日期
    appointmentEndDate?: string // 预约结束日期
    typePk?: string // 预约类型pk
}
export const getAppointmentBoardList = (options: GetAppointmentBoardListOptions) => postJSON('appointmentBill/selectAppointmentLookBoardList', options)

// 更新提醒次数
export const updateAppointmentRemindCount = (billPk: string) => post('appointmentBill/updateRemindCount', { billPk })

// 改期
interface UpdateAppointmentInfoOptions {
    appointmentDate: string // 预约日期
    billPk: string // 预约单pk 
    carOwnerRemark: string // 预约备注
    cfgPk: string // 时间段配置pk
}
export const updateAppointmentInfo = (options: UpdateAppointmentInfoOptions) => post('appointmentBill/updateAppointmentDate', options)

// 查询预约单详情
export const getAppointmentInfo = (pk: string) => get('appointmentBill/selectByPk', { pk })

// 获取天气
export const getCityWeatherList = (city: string) => get('appointmentBill/weatherQuery', {
    city
})

// 确认
export const updateAppointmentStatus = (billPk: string) => post('appointmentBill/confirm', { billPk })

// 获取简单的权益集合
export const getFilterEquityList = (options: any) => postJSON('equity/getFilterEquityList', options)

